import { FC, HTMLAttributes } from 'react'

import { styled } from 'styled-components'

const VisuallyHiddenBase: FC<HTMLAttributes<HTMLSpanElement>> = (props) => <span aria-hidden='false' {...props} />

/**
 * @deprecated Prefer `aira-*` attributes such as `aira-label`. If you really do need a hidden label for
 * accessibility use `@radix-ui/react-visually-hidden`
 * */
const VisuallyHidden = styled(VisuallyHiddenBase)`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  white-space: nowrap;
`

export default VisuallyHidden
